import React, { useEffect } from "react";
import { DetailCard, SubPageSectionDetail } from "../components";
import { redirections } from "../utils/constants";
import { useLocation } from "react-router-dom";

function MainDashboard() {
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };
  // const handleCloseModal = () => {
  //   setIsModalOpen(false);
  // };

  useEffect(() => {
    const mainElement = document.getElementsByTagName("main")[0];
    if (mainElement) {
      mainElement.classList.add("lg:bg-cover");
      return () => {
        mainElement.classList.remove("lg:bg-cover");
      };
    }
  }, [location]);

  return (
    <div className="relative">
      <div className="max-w-[700px] mx-auto text-center relative">
        <h1
          style={{
            fontSize: "clamp(2.75rem, 1.737rem + 5.063vw, 6.75rem)",
            lineHeight: "clamp(3rem, 2.399rem + 3.006vw, 5.375rem)",
          }}
          className="font-bold font-sans uppercase tracking-[-2.25px] laptop:tracking-[-5.4px] gradient-text bg-left-bottom bg-textGd mb-[1rem]"
        >
          GETTING <br /> STARTED
        </h1>
        <SubPageSectionDetail className="max-w-[480px] mx-auto">
          Welcome to the Vanar Hub. Here, you can explore the key
          functionalities of the Vanar ecosystem.
        </SubPageSectionDetail>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 mx-auto max-w-[1244px] gap-6 lg:gap-10 xxl:gap-20 mt-8 lg:mt-[40px]">
        <DetailCard
          onClick
          id="claimOrStakeYourTokens"
          icon={`${process.env.REACT_APP_S3_ASSETS_URL}claim-prestack.webp`}
          title="Claim Your Prestakes"
          detail="Claim rewards on your Prestaked $VANRY. you can get access to farming, staking and other benefits."
          linkText="Claim or Stake Your Tokens"
          url={redirections.CLAIM_PRE_STAKE}
          urlTarget="_blank"
          btn={
            <>
              Claim or Stake <br /> Your Tokens
            </>
          }
        />
        {/* <div className="col-span-1" onClick={handleOpenModal}></div> */}
        <DetailCard
          id="knowMore"
          icon={`${process.env.REACT_APP_S3_ASSETS_URL}bridge-vanarchain.webp`}
          title="Bridge to Vanar Chain"
          detail="By bridging $VANRY from ETH to Vanar you can get access to farming, staking and other benefits."
          linkText="Know More"
          url="/bridge"
          urlTarget="_self"
          btn={
            <>
              Know
              <br /> More
            </>
          }
        />
        <DetailCard
          id="stakeNow"
          icon={`${process.env.REACT_APP_S3_ASSETS_URL}vanarcoin.webp`}
          title="Stake & Earn"
          detail="Stake $VANRY to earn rewards, secure the network and participate in shaping the future of the blockchain."
          linkText="Stake Now"
          url={redirections.DPOS}
          urlTarget="_blank"
          linkGuide="Guide"
          btn={
            <>
              STake <br />
              now
            </>
          }
        />
      </div>
      {/* <ExploreBridgeModal isToggled={isModalOpen} setToggled={handleCloseModal} /> */}
    </div>
  );
}

export default MainDashboard;
